import React from "react";
import HomeContent from "../function-components/BusinessPOC/HomeContent";

function Home() {
 return (
  <>
   <HomeContent />
  </>
 );
}

export default Home;
